export function normalizeResource(resource) {
  if (resource) {
    return {
      capabilities: resource.capabilities,
      createDate: Date.parse(resource.createDate),
      id: resource.id,
      changeDate: Date.parse(resource.changeDate),
      uploader: resource.uploader,
      description: resource.description,
      name: resource.name,
      type: resource.type,
      size: resource.size,
      filesChildrenCount: resource.filesChildrenCount || '0',
      foldersChildrenCount: resource.foldersChildrenCount || '0',
      isSystemFolder: resource.isSystemFolder,
      systemFolderType: resource.systemFolderType,
      parentId: resource.parentId ? resource.parentId : null,
      ancestors: resource.ancestors ? resource.ancestors : null,
      path: resource.path,
      searchString: resource.searchString,
      shared: resource.shared,
      isOneDrive: resource.isOneDrive,
      insuredVisible: resource.insuredVisible,
      systemFolderType: resource?.systemFolderType,
      noteId: resource?.noteId,
      taskId: resource?.taskId,
      serviceRequestId: resource?.serviceRequestId,
    };
  } else {
    return {};
  }
}

export function normalizeTransferItem(item) {
  if (item) {
    return {
      id: item.id,
      name: item.name,
    };
  } else {
    return null;
  }
}
